import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

/**
 * Providence Microcopy component.
 * @see {@link https://providence.fmr.com/4.x/components/microcopy/microcopy.html|Microcopy documentation}
 */
class PvdMicrocopy extends PvdSlotifyBaseComponent {
    // #endregion
    // #region private methods
    get hasText() {
        return !!this.pvdText || this.isSlotUsed();
    }
    //#endregion
    // #region LitElement lifecycles
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-microcopy-root`,
            modifierPrefix: 'pvd-microcopy',
            modifiers: [],
        };
        return x `<div class="${getClassName(classMap)}" id="${l(this.pvdId)}">${this.hasText
            ? x `<p class="pvd-microcopy__microcopy"><s-slot>${this.pvdText}</s-slot></p>`
            : x `<s-slot></s-slot>`}</div>`;
    }
}
//#region Component configuration
PvdMicrocopy.componentName = 'microcopy';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-id' }),
    __metadata("design:type", String)
], PvdMicrocopy.prototype, "pvdId", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdMicrocopy.prototype, "pvdText", void 0);

export { PvdMicrocopy };
//# sourceMappingURL=pvd-microcopy.js.map
